import { log } from "console";
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

//TODO use parseUrl
import parseUrl from "parse-url";

/**
 * Get an array of the values from the url.
 *
 * @param querystring - The querystring to parse, often will be window.location.search.
 * @returns Returns an array of facet names and values.
 */
export const parseFacetUrlParams = (url: string): string[][] => {
	if (isStringEmpty(url)) {
		return [[], []];
	}

	let parsedUrl = new URL(url);

	const searchParams = new URLSearchParams(parsedUrl.hash);

	let matchedParams = [];
	for (const p of searchParams) {
		let paramName = p[0].replace("#", "");
		let paramValue = p[1];

		if (paramName.startsWith("f:")) {
			let facetName = paramName.replace("f:", "");

			let facetValue = paramValue.replace("[", "");
			facetValue = facetValue.replace("]", "");

			matchedParams.push([facetName, facetValue]);
		}
	}

	return matchedParams;

	// let matchedParams = searchParams..filter(function (queryParam) {
	// 	return queryParam.substring(0, 2) === "f:";
	// });

	// console.log("matchedParams");
	// console.log(matchedParams);

	// return matchedParams.map(function (match) {
	// 	match = match.replace("[", "");
	// 	match = match.replace("]", "");
	// 	match = match.replace("f:", "");

	// 	return match.split("=");
	// });
};
